import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { isNil, join, upperFirst } from 'lodash'
import withRouter from '../../lib/withRouter'
import actions from '../../actions/Users'

export class UserShow extends Component {
  static propTypes = {
    show: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    attributes: PropTypes.object,
    params: PropTypes.object
  }

  componentDidMount() {
    this.props.show(this.id)
  }

  componentWillUnmount() {
    this.props.reset()
  }

  get id() {
    return this.props.params.id
  }

  roleNames = () => {
    return join(this.props.attributes.roles, ', ')
  }

  render() {
    const { attributes } = this.props

    if (isNil(attributes)) {
      return null
    }

    return (
      <div className="content">
        <h2>User Info</h2>
        <table className="pure-table">
          <tbody>
            <tr>
              <td><strong>Username</strong></td>
              <td>{attributes.username}</td>
            </tr>
            <tr>
              <td><strong>Email</strong></td>
              <td>{attributes.email}</td>
            </tr>
            <tr>
              <td><strong>User Type</strong></td>
              <td>{upperFirst(attributes.user_type)}</td>
            </tr>
            <tr>
              <td><strong>Roles</strong></td>
              <td>{this.roleNames()}</td>
            </tr>

          </tbody>
        </table>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const slice = state.users.show

  return {
    id: slice.id,
    attributes: slice.attributes
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  show: actions.show.main,
  reset: actions.show.reset
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserShow))
